import { Identifiable, Project, projectStatus, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";
import { LinkedProject, Linker } from "../linkers/types";
import { mapError } from "../utils/mapError";

type Response = LinkedProject;

function duplicateProject(httpClient: HttpClient, linker: Linker) {
  return (
    sourceProject: Identifiable<Project>,
    project: Project,
    zone: Identifiable<Zone>,
  ) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${sourceProject.uuid}/duplicate`,
        method: HttpMethods.POST,
        headers:
          project.isTemplate || ("template" in project && project.template)
            ? { "force-template-duplication": "true" }
            : undefined,
        data: {
          name: project.name,
          description: project.description,
          ...(project.rootList.startDate && {
            startDate: formatDate(project.rootList.startDate),
          }),
          ...(project.rootList.endDate && {
            endDate: formatDate(project.rootList.endDate),
          }),
          tags: project.tags.map((tag) =>
            typeof tag === "string" ? tag : tag.name,
          ),
          status: `projectStatuses/${project.status.uuid}`,
          zone: `zones/${zone.uuid}`,
          data: sourceProject.data,
          attributes: sourceProject.attributes,
        },
      })
      .then(linker.linkProject)
      .then((project) => ({
        ...project,
        status: project.status || projectStatus,
        isTemplate: project.isTemplate || (project.template as boolean),
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            invalidProjectName: "invalidProjectName",
          }),
        ),
      );
}

export { duplicateProject };
